const TRANSACTION_ID_PATTERN = /^txn_[a-z0-9]+$/i;

let pendingTransactionId: string | null = null;

export function captureCheckoutTransactionFromUrl(search: string): void {
  const candidate = new URLSearchParams(search).get('_ptxn');
  pendingTransactionId = candidate && TRANSACTION_ID_PATTERN.test(candidate) ? candidate : null;
}

export function getPendingCheckoutTransactionId(): string | null {
  return pendingTransactionId;
}
